import { render, staticRenderFns } from "./NotifJoinRequest.vue?vue&type=template&id=771ff88c&scoped=true"
import script from "./NotifJoinRequest.vue?vue&type=script&lang=js"
export * from "./NotifJoinRequest.vue?vue&type=script&lang=js"
import style0 from "./NotifJoinRequest.vue?vue&type=style&index=0&id=771ff88c&prod&lang=scss&scoped=true"
import style1 from "./NotifStyle.scss?vue&type=style&index=1&id=771ff88c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ff88c",
  null
  
)

export default component.exports